import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSectionStart } from "../../redux/section/reducer";
import {
  selectCurrentSection,
  selectSingleSectionLoading,
} from "../../redux/section/selectors";

const useSectionGet = ({ id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectSingleSectionLoading);
  const section = useSelector(selectCurrentSection);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const fetchSection = useCallback(() => {
    if (id) {
      dispatch(getSectionStart({ id }));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (id) {
      fetchSection();
    }
  }, [id, fetchSection, fetch]);

  return {
    fetchSection,
    section,
    isLoading,
    refetch,
  };
};

export default useSectionGet;
